import { frontendURL } from '../../../helper/URLHelper';

const SettingsContent = () => import('./Wrapper.vue');

// Shared by uraIntegration.routes.js and tmsIntegration.routes.js - both
// features expose a single settings page behind the same Wrapper.vue layout,
// varying only path, header title, route name, component and (optionally)
// roles/icon.
export function createIntegrationSettingsRoute({
  path,
  headerTitle,
  routeName,
  component,
  roles = ['administrator', 'master'],
  icon = 'link',
}) {
  return {
    routes: [
      {
        path: frontendURL(path),
        component: SettingsContent,
        props: () => ({
          headerTitle,
          icon,
          showBackButton: false,
          backUrl: '',
        }),
        children: [
          {
            path: '',
            name: routeName,
            component,
            roles,
          },
        ],
      },
    ],
  };
}
